import ApiClient from './ApiClient';

class SectorAPI extends ApiClient {
  constructor() {
    super('sectors', { accountScoped: true });
  }
}

export default new SectorAPI();
